const today = '2026-06-23';
const yesterday = '2026-06-22';
let _nextId = 1;
export function setNextId(id) { _nextId = id; }
export function getNextId() { return _nextId; }

function createNode(opts) {
  return {
    id: `node-${_nextId++}`, name: opts.name, path: opts.path, kind: opts.kind ?? 'folder',
    icon: opts.icon ?? (opts.kind === 'folder' ? 'folder' : 'document'),
    children: opts.children ?? [], appId: opts.appId ?? null, modified: opts.modified ?? today,
    size: opts.size ?? '--', content: opts.content ?? null, mimeType: opts.mimeType ?? null,
    originalPath: opts.originalPath ?? null,
  };
}

function folder(name, path, icon = 'folder', children = [], modified = today) {
  return createNode({ name, path, icon, children, modified });
}

function app(name, path, icon, appId) {
  return createNode({ name, path, kind: 'app', icon, appId, modified: today, size: '--' });
}

function file(name, path, icon = 'document', size = '4 KB', appId = null, modified = today, content = null, mimeType = null) {
  return createNode({ name, path, kind: 'file', icon, size, appId, modified, content, mimeType });
}

let root = folder('Macintosh HD', '/', 'drive-hd', [
  folder('Applications', '/Applications', 'sidebar-apps', [
    app('Finder.app', '/Applications/Finder.app', 'finder', 'projects'),
    app('Welcome.app', '/Applications/Welcome.app', 'welcome', 'welcome'),
    app('Resume.app', '/Applications/Resume.app', 'resume', 'resume'),
    app('Global Chat.app', '/Applications/Global Chat.app', 'chat', 'chat'),
    app('Graphite Tiles.app', '/Applications/Graphite Tiles.app', 'game', 'game'),
    app('Contact.app', '/Applications/Contact.app', 'mail', 'contact'),
    app('About This Mac.app', '/Applications/About This Mac.app', 'computer', 'about'),
    app('System Preferences.app', '/Applications/System Preferences.app', 'gear', 'control-panel'),
    app('Content Editor.app', '/Applications/Content Editor.app', 'content-editor', 'content-editor'),
    app('TextEdit.app', '/Applications/TextEdit.app', 'document', 'textedit'),
    app('Preview.app', '/Applications/Preview.app', 'pdf-document', 'preview'),
    app('Terminal.app', '/Applications/Terminal.app', 'terminal', 'terminal'),
    app('Safari.app', '/Applications/Safari.app', 'safari', 'safari'),
    app('Calculator.app', '/Applications/Calculator.app', 'calculator', 'calculator'),
    app('Calendar.app', '/Applications/Calendar.app', 'calendar', 'calendar'),
    app('Notes.app', '/Applications/Notes.app', 'notes', 'notes'),
    app('Stickies.app', '/Applications/Stickies.app', 'stickies', 'stickies'),
    app('Weather.app', '/Applications/Weather.app', 'cloud', 'weather'),
    app('Contacts.app', '/Applications/Contacts.app', 'address-book', 'contacts'),
    app('Messages.app', '/Applications/Messages.app', 'chat', 'chat'),
    app('QuickTime Player.app', '/Applications/QuickTime Player.app', 'quicktime', 'quicktime'),
    app('Gallery.app', '/Applications/Gallery.app', 'gallery', 'gallery'),
    app('Activity Monitor.app', '/Applications/Activity Monitor.app', 'activity-monitor', 'activity-monitor'),
    app('Software Update.app', '/Applications/Software Update.app', 'software-update', 'software-update'),
    app('AquaPaint.app', '/Applications/AquaPaint.app', 'aquapaint', 'aquapaint'),
    app('Photos.app', '/Applications/Photos.app', 'image-file', 'photos'),
    app('Photo Booth.app', '/Applications/Photo Booth.app', 'welcome', 'photobooth'),
    app('Freeform.app', '/Applications/Freeform.app', 'freeform', 'freeform'),
    app('Journal.app', '/Applications/Journal.app', 'document', 'journal'),
    app('Books.app', '/Applications/Books.app', 'pdf-document', 'books'),
    app('Screen Capture.app', '/Applications/Screen Capture.app', 'computer', 'screen-capture'),
    app('Music.app', '/Applications/Music.app', 'music', 'music'),
    app('Font Book.app', '/Applications/Font Book.app', 'font-file', 'font-book'),
    app('Dictionary.app', '/Applications/Dictionary.app', 'document', 'dictionary'),
    app('Trash.app', '/Applications/Trash.app', 'trash', 'trash'),
  ]),
  folder('Library', '/Library', 'folder-library', [
    folder('Application Support', '/Library/Application Support', 'folder-library', [
      folder('AquaOS', '/Library/Application Support/AquaOS', 'folder', [
        file('desktop.plist', '/Library/Application Support/AquaOS/desktop.plist', 'document', '12 KB'),
        file('dock.plist', '/Library/Application Support/AquaOS/dock.plist', 'document', '8 KB'),
      ]),
    ]),
    folder('Fonts', '/Library/Fonts', 'folder-documents', [
      file('LucidaGrande.ttc', '/Library/Fonts/LucidaGrande.ttc', 'font-file', '2.4 MB', null, yesterday),
      file('AquaDisplay.dfont', '/Library/Fonts/AquaDisplay.dfont', 'font-file', '612 KB', null, yesterday),
    ]),
    folder('Preferences', '/Library/Preferences', 'folder-library', [
      file('com.aquaos.finder.plist', '/Library/Preferences/com.aquaos.finder.plist', 'document', '16 KB'),
    ]),
  ]),
  folder('System', '/System', 'system-folder', [
    folder('Library', '/System/Library', 'folder-library', [
      folder('CoreServices', '/System/Library/CoreServices', 'system-folder', [
        app('Finder.app', '/System/Library/CoreServices/Finder.app', 'finder', 'projects'),
        file('SystemVersion.plist', '/System/Library/CoreServices/SystemVersion.plist', 'document', '6 KB'),
      ]),
      folder('Extensions', '/System/Library/Extensions', 'folder-library', [
        file('IOGraphicsFamily.kext', '/System/Library/Extensions/IOGraphicsFamily.kext', 'package', '1.1 MB', null, yesterday),
        file('AppleSMC.kext', '/System/Library/Extensions/AppleSMC.kext', 'package', '740 KB', null, yesterday),
      ]),
    ]),
  ]),
  folder('Users', '/Users', 'folder', [
    folder('Guest', '/Users/Guest', 'sidebar-home', [
      folder('Desktop', '/Users/Guest/Desktop', 'folder-desktop', [
        app('Welcome.app', '/Users/Guest/Desktop/Welcome.app', 'welcome', 'welcome'),
        file('Portfolio.webloc', '/Users/Guest/Desktop/Portfolio.webloc', 'web-link', '2 KB', 'about'),
        folder('Screenshots', '/Users/Guest/Desktop/Screenshots', 'folder-pictures', [
          file('Finder Reference.png', '/Users/Guest/Desktop/Screenshots/Finder Reference.png', 'image-file', '418 KB'),
        ]),
      ]),
      folder('Documents', '/Users/Guest/Documents', 'folder-documents', [
        file('Resume.pdf', '/Users/Guest/Documents/Resume.pdf', 'resume', '225 KB', null, today, '/documents/resume.pdf', 'application/pdf'),
        file('About Me.rtf', '/Users/Guest/Documents/About Me.rtf', 'document', '28 KB', null, today, 'AquaOS is a playful browser desktop built as a developer portfolio.', 'text/rtf'),
        file('AquaOS Handbook.epub', '/Users/Guest/Documents/AquaOS Handbook.epub', 'document', '1.9 KB', null, today, '/documents/aquaos-handbook.epub', 'application/epub+zip'),
        file('Contact Card.vcf', '/Users/Guest/Documents/Contact Card.vcf', 'mail', '45 KB', 'contact', yesterday),
      ]),
      folder('Downloads', '/Users/Guest/Downloads', 'folder-downloads', [
        file('aqua-chat-build.zip', '/Users/Guest/Downloads/aqua-chat-build.zip', 'archive', '3.8 MB', null, yesterday),
        file('project-notes.txt', '/Users/Guest/Downloads/project-notes.txt', 'document', '14 KB', null, yesterday, 'Phase 1: persistent filesystem, Finder navigation, Preview, TextEdit, Terminal, and Trash.', 'text/plain'),
      ]),
      folder('Library', '/Users/Guest/Library', 'folder-library', [
        folder('Preferences', '/Users/Guest/Library/Preferences', 'folder-library', [
          file('com.aquaos.sidebar.plist', '/Users/Guest/Library/Preferences/com.aquaos.sidebar.plist', 'document', '7 KB'),
        ]),
        folder('Caches', '/Users/Guest/Library/Caches', 'folder-library', [
          file('finder-icon-cache.db', '/Users/Guest/Library/Caches/finder-icon-cache.db', 'document', '96 KB'),
        ]),
      ]),
      folder('Movies', '/Users/Guest/Movies', 'folder-movies', [
        file('desktop-tour.mp4', '/Users/Guest/Movies/desktop-tour.mp4', 'movie-file', '1.6 MB', null, today, '/media/desktop-tour.mp4', 'video/mp4'),
      ]),
      folder('Music', '/Users/Guest/Music', 'folder-music', [
        file('boot-chime.mp3', '/Users/Guest/Music/boot-chime.mp3', 'audio-file', '24 KB', null, today, '/media/boot-chime.mp3', 'audio/mpeg'),
      ]),
      folder('Pictures', '/Users/Guest/Pictures', 'folder-pictures', [
        file('Aurora Wallpaper.jpg', '/Users/Guest/Pictures/Aurora Wallpaper.jpg', 'image-file', '940 KB', null, today, '/wallpaper/aurora.jpg', 'image/jpeg'),
        file('Dock Icons.png', '/Users/Guest/Pictures/Dock Icons.png', 'image-file', '628 KB', null, today, '/icons/finder.png', 'image/png'),
      ]),
      folder('Public', '/Users/Guest/Public', 'folder-public', [
        folder('Drop Box', '/Users/Guest/Public/Drop Box', 'folder-public', []),
      ]),
      folder('Sites', '/Users/Guest/Sites', 'folder-sites', [
        file('index.html', '/Users/Guest/Sites/index.html', 'web-link', '18 KB'),
      ]),
      folder('Projects', '/Users/Guest/Projects', 'folder-projects', [
        file('MeeeHub.project', '/Users/Guest/Projects/MeeeHub.project', 'finder', '64 KB', 'projects'),
        file('AquaOS.project', '/Users/Guest/Projects/AquaOS.project', 'finder', '92 KB', 'projects'),
        file('Global Chat.project', '/Users/Guest/Projects/Global Chat.project', 'chat', '56 KB', 'chat'),
      ]),
      folder('.Trash', '/Users/Guest/.Trash', 'trash', []),
    ]),
    folder('Shared', '/Users/Shared', 'folder-public', [
      folder('Public', '/Users/Shared/Public', 'folder-public', [
        file('Read Me.rtf', '/Users/Shared/Public/Read Me.rtf', 'document', '9 KB'),
      ]),
    ]),
  ]),
  folder('Volumes', '/Volumes', 'drive-hd', [
    folder('Quillink', '/Volumes/Quillink', 'drive-hd', [
      folder('Backups.backupdb', '/Volumes/Quillink/Backups.backupdb', 'system-folder', [
        folder('AquaOS Snapshot', '/Volumes/Quillink/Backups.backupdb/AquaOS Snapshot', 'folder-documents', []),
      ]),
      file('System Notes.rtf', '/Volumes/Quillink/System Notes.rtf', 'document', '82 KB', null, yesterday),
    ]),
    folder('Cruzer', '/Volumes/Cruzer', 'drive-usb', [
      folder('Installers', '/Volumes/Cruzer/Installers', 'folder-downloads', [
        file('AquaOS Preview.dmg', '/Volumes/Cruzer/Installers/AquaOS Preview.dmg', 'drive-hd', '24.8 MB'),
      ]),
      folder('Screenshots', '/Volumes/Cruzer/Screenshots', 'folder-pictures', [
        file('black-snow-leopard-finder.png', '/Volumes/Cruzer/Screenshots/black-snow-leopard-finder.png', 'image-file', '522 KB'),
      ]),
    ]),
    folder('iDisk', '/Volumes/iDisk', 'idisk', [
      folder('Documents', '/Volumes/iDisk/Documents', 'folder-documents', [
        file('Public Folder.rtf', '/Volumes/iDisk/Documents/Public Folder.rtf', 'document', '11 KB', null, yesterday),
      ]),
      folder('Pictures', '/Volumes/iDisk/Pictures', 'folder-pictures', [
        file('MobileMe Gallery.jpg', '/Volumes/iDisk/Pictures/MobileMe Gallery.jpg', 'image-file', '386 KB', null, yesterday),
      ]),
    ]),
  ]),
  folder('Network', '/Network', 'shared-mac', [
    folder('Richard XXI', '/Network/Richard XXI', 'shared-mac', [
      folder('Public Drop Box', '/Network/Richard XXI/Public Drop Box', 'folder-public', [
        file('hello-from-richard.txt', '/Network/Richard XXI/Public Drop Box/hello-from-richard.txt', 'document', '1 KB'),
      ]),
    ]),
  ]),
]);

export { today, yesterday, createNode, folder, app, file, root };
